import './index.css';
import React from 'react';
import HGChart from 'components/HGChart';
import { DeviceTypes } from './constants';
import { useDevice } from './service';
import { getMasterConfig } from './EditDeviceProfile/helper';
import { useVerifyCustomer, useVerifyAdmin } from 'helper';
import { getDeviceType, verifySingleStack, useGetIDsFromURL } from './helper';
import MicroinvertersTable from './MicroinvertersTable';
import BatteryStacksTable from './BatteryStacksTable';
import BatteryModulesTable from './BatteryModulesTable';
import ModuleData from './ModuleData';
import UpgradeHistory from './UpgradeHistory';
import WarrantyConfirmation from './warrantyConfirmation';
import ReportDownloadList from './ReportDownloadList';
import TabbedCard from './TabbedCard';
import DeviceProfileTab from './DeviceProfileTab';
import StackData from './StackData';

const DeviceDetails = () => {
    const isCustomer = useVerifyCustomer();
    const isAdmin = useVerifyAdmin();
    const { Thing_ID, BMS_ID, Module_ID } = useGetIDsFromURL();
    const { data: device, isLoading } = useDevice(Thing_ID);
    // NOTE: due to how the route is structured "/devices/:Thing_ID/:BMS_ID/:Module_ID",
    // single stack id is used for module id in order to force deviceType to be MODULE
    // as the route is / devices /: Thing_ID /: Module_ID
    const { SINGLE_BMS_ID } = verifySingleStack(device);
    const deviceType = getDeviceType(device, BMS_ID, Module_ID);

    const masterConfig = getMasterConfig(
        device?.Config?.data?.MASTER_SNS,
        SINGLE_BMS_ID ?? BMS_ID
    );

    // set tabs and tabComponents
    const tabConfig = [
        {
            title: 'Device Profile',
            component: (
                <DeviceProfileTab
                    showSideload={
                        isAdmin &&
                        (deviceType === DeviceTypes.EMS ||
                            deviceType === DeviceTypes.BMS)
                    }
                />
            ),
        },
        ...(deviceType === DeviceTypes.EMS || deviceType === DeviceTypes.BMS
            ? [
                  {
                      title: 'Stack Data',
                      component: <StackData device={device} />,
                  },
              ]
            : []),
        ...(deviceType === DeviceTypes.EMS
            ? [
                  {
                      title: 'Battery Stacks',
                      component: (
                          <BatteryStacksTable
                              mastersConfigs={device?.Config?.data?.MASTER_SNS}
                              activeAlerts={device?.active_alerts}
                              loading={isLoading}
                          />
                      ),
                  },
              ]
            : []),
        ...(deviceType === DeviceTypes.BMS
            ? [{ title: 'Battery Modules', component: <BatteryModulesTable /> }]
            : []),
        ...(deviceType === DeviceTypes.MODULE
            ? [{ title: 'Module Data', component: <ModuleData /> }]
            : []),
        ...(deviceType === DeviceTypes.NEP
            ? [{ title: 'Microinverters', component: <MicroinvertersTable /> }]
            : []),
        { title: 'Upgrade History', component: <UpgradeHistory /> },
        {
            title: 'Reports',
            component: <ReportDownloadList deviceId={Thing_ID} />,
        },
    ];

    return (
        <div className="flex flex-col gap-5">
            <HGChart
                devices={
                    (Module_ID || (SINGLE_BMS_ID && BMS_ID)
                        ? masterConfig?.PACKS
                        : device?.Config?.data?.MASTER_SNS) ?? []
                }
            />
            <TabbedCard tabConfig={tabConfig} />

            {isCustomer && device?.warranty && (
                <WarrantyConfirmation warrantyData={device.warranty} />
            )}
        </div>
    );
};

export default DeviceDetails;
